/**
 * What the rest of the app may know about the career site being rendered.
 *
 * `PositionDetails` is rendered inside the site chrome unchanged; the only way
 * it adapts is through `getPositionContext` in `services/api.ts`, which reads
 * this module. Outside career mode the context is `null` and nothing changes.
 */

export interface CareerSiteContext {
  /** Apply site whose config the position pages use. */
  applicationPageCode: string;
  language: string;
  faviconUrl: string | null;
  logoUrl: string | null;
}

let current: CareerSiteContext | null = null;

export function setCareerSiteContext(context: CareerSiteContext | null): void {
  current = context;
}

export function getCareerSiteContext(): CareerSiteContext | null {
  return current;
}

/**
 * The portal on screen, while one is: which `localStorage` key holds its
 * token, so `services/api.ts` reads the site's own session instead of the
 * legacy key, and where its gate is, so a position page sends a visitor
 * whose token stopped working back inside the site.
 */
export interface PortalSession {
  tokenKey: string;
  home: string;
}

let portal: PortalSession | null = null;

export function setPortalSession(session: PortalSession | null): void {
  portal = session;
}

export function getPortalSession(): PortalSession | null {
  return portal;
}
